import { generateId } from '@freelancer/datastore/testing';
import { TotpMethodsApi } from 'api-typings/auth/auth';
import { UsersMfa } from './users-mfa.model';

export type GenerateUsersMfaOptions = Partial<UsersMfa>;

/**
 * Generate MFA for a user where email is the only available method and MFA is disabled
 */
export function generateUsersMfaObject({
  id = generateId(),
  mfa = {
    availableMethods: [TotpMethodsApi.EMAIL],
  },
}: GenerateUsersMfaOptions = {}): UsersMfa {
  return { id, mfa };
}

/**
 * Generate MFA for a user where they have successfully added their phone number and MFA is disabled.
 */
export function generateUsersMfaPhoneVerified(): GenerateUsersMfaOptions {
  return {
    mfa: {
      availableMethods: [TotpMethodsApi.SMS, TotpMethodsApi.EMAIL],
    },
  };
}
